// extracted by mini-css-extract-plugin
export var container = "exhibit-section-module--container--KLPZb";
export var content = "exhibit-section-module--content--mvTuE";
export var darkFont = "exhibit-section-module--darkFont--P3bFY";
export var image = "exhibit-section-module--image--q+TNO";
export var lightFont = "exhibit-section-module--lightFont--Z5J7H";
export var textContainer = "exhibit-section-module--textContainer--jCrwf";